define(["core/jed","/home/jenkins/build/workspace/005-dispatch2-build-pipeline/web/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js",""], function(loader, runner) {
   return runner(loader, "core/nls/load", __webpack_require__.dj.c(), true);
});